import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby';
import Image from '../components/image';
import Link from '../components/link';
import RightArrow from '-!svg-react-loader!../assets/images/menu-arrow.svg';
import axios from 'redaxios';
/* import GravityFormForm from 'gatsby-plugin-gravity-forms';
 */import { StaticImage } from 'gatsby-plugin-image';

const Footer = () => {
    const footerQuery = useStaticQuery(graphql`
    query {
        form: wpGfForm(title: {eq: "Newsletter"}) {
            ...GravityFormFields
        }
        wp {
            themeOptions {
              acfThemeOptions {
                social {
                    title
                    url
                    icon {
                      altText
                      localFile {
                        publicURL
                        childCloudinaryAsset {
                          gatsbyImageData
                        }
                      }
                    }
                  }
                  locations {
                    hours
                    location {
                      addressText
                      addressUrl {
                        url
                        title
                        target
                      }
                      fax {
                        target
                        title
                        url
                      }
                      name
                      email
                      tel {
                        target
                        title
                        url
                      }
                    }
                  }
                footerLinks {
                  links {
                    title
                    items {
                      link {
                        target
                        title
                        url
                      }
                    }
                  }
                }
              }
            }
          }
    }
  `)
    const links = footerQuery.wp.themeOptions.acfThemeOptions.footerLinks.links;
    const socials = footerQuery.wp.themeOptions.acfThemeOptions.social;
    const hours = footerQuery.wp.themeOptions.acfThemeOptions.locations.hours;
    const locations = footerQuery.wp.themeOptions.acfThemeOptions.locations.location;
    const [active, setActive] = useState(locations[0]);
    const [kFormErrors, setKFormErrors] = useState(false);
    const [kFormSuccess, setKFormSuccess] = useState(false);

    const submitFakeKlaviyo = (e) => {
      e.preventDefault();
      const formData = new FormData(e.target.closest('form'));

      axios({
        url: `https://a.klaviyo.com/client/subscriptions/?company_id=V3E6LL`,
        method: 'POST',
        headers: {
          revision: '2024-04-15',
          'content-type': 'application/json',
        },
        data: {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website footer signup form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: formData.get('email'),
                  },
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list', 
                  id: 'VCE9eS'
                }
              }
            }
          },
        },
      }).then((response) => {
        if(response.data?.errors) {
          setKFormErrors(response.data.errors);
          return false
        }

        if(!response.ok) {
          setKFormErrors([{detail: 'Something went wrong.'}]);
          return false;
        }

        setKFormSuccess(true)
        setKFormErrors(false)
      }).catch((response) => {
        if(response.data?.errors) {
          setKFormErrors(response.data.errors);
          return false
        }

        if(!response.ok) {
          setKFormErrors([{detail: 'Something went wrong.'}]);
          return false;
        }
      })
    }


    return (
        <footer className='Footer'>
            <div className="Footer__wrapper">
                <section className='Footer__top'>
                  <Link to="/">
                    <StaticImage
                      src="../assets/images/logo.png"
                      className="Footer__top__logo"
                      alt="footer logo"
                      width={261}
                      transformOptions={{fit: "contain"}}
                    />
                  </Link>
                </section>
                <section className='Footer__middle'>
                    <div className="Container">
                        <div className="Footer__middle__wrapper">
                            <div className="Footer__middle__links Footer__middle__col">
                                {links.map((link, i) => (
                                    <div className="Footer__middle__links__item" key={i}>
                                        <h3>{link.title}</h3>
                                        <ul>
                                            {link.items.map((item, i) => (
                                                <li key={i}><Link acfLink={item.link} /></li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                            <div className="Footer__middle__locations Footer__middle__col">
                                <div className="Footer__locations__left">
                                    <div className="Footer__locations__tabs">
                                        {locations.map((loc, i) => (
                                            <button className={`notbutton${loc === active ? ' active' : ''}`} key={i} onClick={() => setActive(loc)}>{loc.name}</button>
                                        ))}
                                    </div>
                                    <div className="Footer__locations__hours">
                                        <h3>Hours</h3>
                                        <div dangerouslySetInnerHTML={{__html: hours}} />
                                    </div>
                                </div>
                                <div className="Footer__locations__right">
                                    <div className="Footer__locations__tel">
                                        <div className='Footer__locations__tel--item'>Tel: <Link acfLink={active.tel} /></div>
                                        <div className='Footer__locations__tel--item'>Fax: <Link acfLink={active.fax} /></div>
                                    </div>
                                    <div className="Footer__locations__address">
                                        <div className="Footer__locations__address--item" dangerouslySetInnerHTML={{__html: active.addressText}}>
                                        </div>
                                        <div className="Footer__locations__address--item">
                                            <Link acfLink={active.addressUrl} />
                                        </div>
                                    </div>

                                    <Link to={`mailto:${active.email}`} className="Footer__locations__mail">EMAIL US <RightArrow /> </Link>
                                </div>
                            </div>
                            <div className="Footer__middle__form Footer__middle__col">
                                <h3>Sign up for our newsletter</h3>
                                <p>Stay in the know. Get inspired and save big with our e-newsletter, featuring the latest products, trends, special offers, and expert advice from the LENCO team.</p>

                                {kFormSuccess ? (
                                  <div className="fake-klaviyo__success">
                                    Thanks for signing up!
                                  </div>
                                ) : (
                                  <form className="fake-klaviyo" onSubmit={submitFakeKlaviyo}>
                                    <input type="email" placeholder="Email Address" name="email" />
                                    <button type="submit" aria-label="submit"><RightArrow /></button>
                                  </form>
                                )}

                                {!kFormSuccess && kFormErrors && kFormErrors.map((error, index) => (
                                  <div className="fake-klaviyo__error" key={index}>
                                    {error.detail}
                                  </div>
                                ))}

                                <div className="Contact__social">
                                    {socials.map((social, i) => (
                                        <Link to={social.url} target="_blank" key={i}><Image source={social.icon.localFile.publicURL} alt="social icon"/></Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='Footer__bottom'>
                    © Copyright {new Date().getFullYear()} LENCO Supplies USA. All Rights Reserved.
                </section>
            </div>
        </footer>
    )
}

export default Footer